import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { toast } from 'react-toastify';

const PaymentVerification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { apiRequest } = useAuth();

  useEffect(() => {
    const verifyPayment = async () => {
      const query = new URLSearchParams(location.search);
      const reference = query.get('reference');
      
      if (!reference) {
        navigate('/orders');
        return;
      }

      try {
        const response = await apiRequest(`/payments/verify?reference=${reference}`);
        if (response.ok) {
          const data = await response.json();
          toast.success('Payment successful!');
          navigate(`/orders/${data.data.order._id}`);
        } else {
          throw new Error('Payment verification failed');
        }
      } catch (error) {
        toast.error(error.message);
        navigate('/checkout');
      }
    };

    verifyPayment();
  }, [location, navigate, apiRequest]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-softRose">
      <div className="text-center p-8 bg-white rounded-lg shadow-sm max-w-md">
        <h2 className="text-2xl font-bold text-slateText mb-4">Verifying Payment...</h2>
        <p className="text-gray-600">Please wait while we confirm your payment</p>
      </div>
    </div>
  );
};

export default PaymentVerification;